/**
 * 국기 이미지 해석기.
 *
 * 왜 이모지를 안 쓰나: Windows 에는 국기 글리프가 없다. 🇰🇷 는 regional indicator 두 글자라
 * 폰트에 국기가 없으면 그대로 'KR' 로 떨어진다(Chrome·Edge 모두). 실제로 가입 국가 목록과
 * 언어 선택기가 전부 'KR' 'JP' 같은 글자로 보이고 있었다 — 2026-10-21.
 *
 * SVG 출처: flag-icons 7.2.3 (lipis, MIT / 국기 도안 자체는 퍼블릭 도메인) 4x3 세트를
 * `src/assets/flags/` 에 필요한 나라만 받아 두었다. CDN 을 타지 않는다.
 * 새 나라 교단이 생기면 같은 세트에서 `<소문자 ISO2>.svg` 를 넣기만 하면 된다.
 */

// eager + ?url — 22개 파일이 자산으로 emit 되고, 실제 화면에 그려진 것만 내려받는다.
const FLAG_URLS = import.meta.glob('../assets/flags/*.svg', {
    eager: true,
    query: '?url',
    import: 'default',
});

const BY_CODE = {};
for (const [path, url] of Object.entries(FLAG_URLS)) {
    const match = /([A-Za-z]{2})\.svg$/.exec(path);
    if (match) BY_CODE[match[1].toUpperCase()] = url;
}

/** ISO 3166-1 alpha-2 → 국기 SVG URL (없으면 null) */
export function countryFlagUrl(code) {
    if (!code) return null;
    return BY_CODE[String(code).trim().toUpperCase()] || null;
}

/**
 * 언어 코드 → 국기로 쓸 나라.
 * 언어와 나라는 1:1 이 아니다(en→US, zhTW→TW). 선택기에 쓸 대표 나라만 정한다.
 */
const LANG_COUNTRY = {
    ko: 'KR', en: 'US', ja: 'JP',
    zhTW: 'TW', 'zh-tw': 'TW', zhCN: 'CN', 'zh-cn': 'CN', zh: 'CN',
    es: 'ES', vi: 'VN', th: 'TH', id: 'ID', ms: 'MY', tl: 'PH',
    de: 'DE', fr: 'FR', pt: 'BR', ru: 'RU',
};

export function languageCountryCode(langCode) {
    if (!langCode) return null;
    const raw = String(langCode).trim();
    return LANG_COUNTRY[raw] || LANG_COUNTRY[raw.toLowerCase()] || null;
}
